var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliderWrapFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1129,
    height: 338,
    viewBox: "0 0 1129 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0119 312.519C74.9712 312.701 74.8334 312.847 74.6534 312.897L41.8979 322.006C41.7264 322.054 41.5424 322.008 41.4134 321.885L16.0523 297.793C15.9233 297.67 15.8681 297.489 15.9069 297.315L23.3254 264.136C23.3661 263.953 23.5039 263.808 23.6839 263.758L56.4394 254.649C56.6109 254.601 56.7949 254.647 56.9239 254.769L82.285 278.862C82.414 278.985 82.4692 279.166 82.4304 279.34L75.0119 312.519Z",
    fill: "#BDC4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.91 48.4402C282.642 49.3835 285.31 46.8716 284.533 44.0878L275.902 13.1797C275.228 10.7652 272.347 9.7707 270.327 11.255L244.468 30.2541C242.139 31.9654 242.689 35.5879 245.421 36.5313L279.91 48.4402Z",
    fill: "#FFA463"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderWrapFront);
export default __webpack_public_path__ + "static/media/SliderWrapFront.b020056b71894875fbe0d6dc28e5b180.svg";
export { ForwardRef as ReactComponent };